/*
These Segment functions are used in Amplitude.js.
The separate file prevents a circular dependency between
 Amplitude.js, and Segment.js
 */
export const getAnonymousId = () => {
  if (window.analytics && window.analytics.user) {
    return window.analytics.user() && window.analytics.user().anonymousId();
  }
  return '';
};

export const anonymousIdWatcher = () =>
  new Promise((resolve) => {
    if (getAnonymousId()) return resolve(true);
    //50 count x 50ms interval = 2.5 sec
    let counter = 0;
    const isLoaded = setInterval(() => {
      const id = getAnonymousId();
      if (counter > 50 || id) {
        clearInterval(isLoaded);
        resolve(true);
      } else {
        counter++;
      }
    }, 50);
  });

export const getAnalyticsUserId = () => {
  let user = null;
  try {
    if (window.analytics.user()) {
      user = window.analytics.user().id();
    }
  } catch (e) {
    console.debug('Segment: Occurred an error while getting user data');
  }
  return user;
};
